import React from "react";
import { Navbar } from "./Navbar";
import { MenuBar } from "./MenuBar";
import { heroFem } from "../images/image";
import { Patrocinadores } from "./smComponents/Patrocinadores";
import { FemPageNavBar } from "./FemPageNavBar";
// import { Patrocinadores } from "./smComponents/Patrocinadores";

export const FemPage = () => {
  return (
    <>
      <MenuBar />
      <Navbar />
      <div className="hero-container">
        <img src={heroFem} alt="psg Logo" className="heroFem" />
      </div>
      <FemPageNavBar/>
      <Patrocinadores />
    </>
  );
};
